import styled from 'styled-components';
import {Text} from '@volkswagen-onehub/components-core';

export const SwitchWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  scale: 100%;

  @media (max-width: 559px) {
    scale: 70%;
    padding: 5px 0px;
  }

  @media (min-width: 560px) and (max-width: 1279px) {
    padding: 24px 0px;
  }
`;

export const StyledSwitch = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 66px;

  /* El ancho depende del contenido + espacio para la bolita */
  padding: 0 10px;
  min-width: 200px;
  border-radius: 100px;
  background-color: #ccc;
  transition: background-color 0.6s;
  overflow: hidden;

  // Fondo cuando está activo/desactivo
  background-color: ${(props) =>
    props.className?.includes('checked') ? '#001E50' : '#00B0F0'};
`;

export const StyledInputCheckbox = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
`;

export const SliderCircle = styled.div<{isReversed: boolean}>`
  position: absolute;
  top: 5px;
  /* Movimiento dinámico */
  left: ${(props) => (props.isReversed ? 'calc(100% - 61px)' : '5px')};
  width: 56px;
  height: 56px;
  background-color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);

  svg {
    width: 24px;
    height: 24px;
    stroke: #001e50;
    transition: transform 0.6s;
    transform: rotate(${(props) => (props.isReversed ? '180deg' : '0deg')});
  }
`;

export const SwitchText = styled(Text)<{isReversed: boolean}>`
  /* Margen dinámico para no chocar con el círculo */
  margin-left: ${(props) => (props.isReversed ? '0' : '40px')};
  margin-right: ${(props) => (props.isReversed ? '40px' : '0')};
  white-space: nowrap;
  padding: 0 20px;
`;
